//#region ../../packages/constants/size.ts
const componentSizes = [
	"",
	"default",
	"small",
	"large"
];
const componentSizeMap = {
	large: 40,
	default: 32,
	small: 24
};

//#endregion
export { componentSizeMap, componentSizes };
//# sourceMappingURL=size.mjs.map